
const ReelLoader = () => {
  const numHoles = 10;
  const holes = Array.from({ length: numHoles });

  return (
    <div className="reel-loader">
      <div className="outerCircle">
        {holes.map((_, i) => {
          const angle = (360 / numHoles) * i;
          return (
            <div
              key={i}
              className="hole"
              style={{ transform: `rotate(${angle}deg) translate(50px)` }}
            ></div>
          );
        })}
        <div className="innerCircle"></div>
      </div>
    </div>
  );
};

export default ReelLoader;
